import { Form, Input } from "antd";
import React from "react";

const WorkerEmail: React.FC = () => {
  return (
    <Form.Item
      name="email"
      label="Email"
      rules={[
        {
          type: "email",
          message: "Please enter a valid email address",
        },
        {
          required: true,
          message: "Please enter your email address",
        },
      ]}
    >
      <Input />
    </Form.Item>
  );
};

export default WorkerEmail;
